import React, { useEffect, useState } from 'react';
import './ODHomePickShapeV2.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getClickCategory } from '../../../../actionCreators/home';
import LazyLoadImage from '../../../CommonComponents/LazyLoadImage/LazyLoadImage';

const ODHomePickShapeV2 = ({ shapes, title }) => {
  const clickCategoryData = useSelector(state => state.home?.clickCategory);
  const [clickCategory, setClickCategory] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (clickCategory && clickCategoryData.data && clickCategoryData.data.urlPath) {
      window.location.href = `/sg/en/${clickCategoryData.data.urlPath}`;
    }
  }, [clickCategory, clickCategoryData]);

  const handleShapeClick = catId => {
    // OD__CLEVERTAP__EVENT (cta_click)
    setClickCategory(true);

    dispatch(getClickCategory(catId));
  };

  return (
    <div className="od-home-pick-shape-v2">
      <div className="od-home-pick-shape-v2__title">{title}</div>
      <div className="od-home-pick-shape-v2__card_container">
        {shapes.map((shape, index) => {
          return (
            <div
              key={index}
              className="od-home-pick-shape-v2__card"
              onClick={() => handleShapeClick(shape.catId)}
            >
              <LazyLoadImage alt={shape?.img?.alt} src={shape?.img?.src} />
              <div className="od-home-pick-shape-v2__card_footer">{shape?.title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ODHomePickShapeV2;
